<template>
  <div
    class="container flex flex-col justify-between md:justify-start fixed w-full screen overflow-auto bg-white"
    :class="{
      'mt-4 pl-0 pt-0 pr-8': isLoginLayout,
      'container-main pt-5': !isLoginLayout,
      'mt-[48.73px] md:mt-[82px]': theme === 'default',
      'md:mt-0 md:pb-[50px] md:pt-0': theme === 'kids',
    }"
  >
    <!-- Menu basic -->
    <template v-if="!isLanguageMenu">
      <div class="h-full md:pb-6 mt-2">
        <div
          v-if="authStore.isLogined"
          class="pb-3 mb-4 border-b-2 border-background"
          :class="{
            'flex justify-between': theme === 'kids',
          }"
        >
          <router-link
            :to="{ name: '/profile' }"
            class="flex items-center"
            @click="$emit('close-menu')"
          >
            <icon-profile class="text-primary w-[32px] h-[32px] mr-2" />
            <span
              class="text--md text-primary"
              :class="{
                uppercase: theme === 'default',
              }"
            >
              {{ authStore.getUser?.userLogin }}
            </span>
          </router-link>
        </div>

        <template v-if="theme === 'default'">
          <h4 class="headline--h4 text-primary mb-4">
            {{ $t("common.catalog") }}
          </h4>

          <MenuCategoryList
            class="md:w-[372px]"
            @close-mobile-menu="$emit('close-menu')"
          />
        </template>
        <template v-else>
          <MenuList
            @open-partner-form="(type) => $emit('open-partner-form', type)"
            @close-mobile-menu="$emit('close-menu')"
          />
        </template>
      </div>

      <MenuActions
        v-show="theme === 'default'"
        class="md:w-[372px]"
        @open-language-menu="isLanguageMenu = true"
      />
    </template>

    <!-- Language menu -->

    <template v-else>
      <MenuLanguage class="md:w-[372px]" @close-menu="$emit('close-menu')" />
    </template>
  </div>
</template>

<script setup>
import {ref} from "vue";
import {useAuthStore} from "../../../stores/authStore";
import MenuCategoryList from "@/components/header/mobile-menu/MenuCategoryList.vue";
import MenuList from "./MenuList.vue";
import MenuActions from "./MenuActions.vue";
import MenuLanguage from "./MenuLanguage.vue";
import {theme} from "@/services/getSiteTheme";

defineEmits({
  "close-menu": null,
  "open-partner-form": null,
});

defineProps({
  isLoginLayout: {
    type: Boolean,
    default: false,
  },
});

const authStore = useAuthStore();

const isLanguageMenu = ref(false);
</script>

<style lang="scss" scoped></style>
